export const referrer = document.referrer || "";
